import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand-more",
  "use": "expand-more-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"expand-more\"><path d=\"M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol